import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=3b901aad"
import script from "./AppLayout.vue?vue&type=script&lang=ts"
export * from "./AppLayout.vue?vue&type=script&lang=ts"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=3b901aad&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/builds/project/wyffest/frontend/components/app/header/AppHeader.vue').default,AppFooter: require('/builds/project/wyffest/frontend/components/app/AppFooter.vue').default,CookieNotice: require('/builds/project/wyffest/frontend/components/cookie/CookieNotice.vue').default})
